import { render, staticRenderFns } from "./PfLoanProfileList.vue?vue&type=template&id=5dd1ae99"
import script from "./PfLoanProfileList.vue?vue&type=script&lang=js"
export * from "./PfLoanProfileList.vue?vue&type=script&lang=js"
import style0 from "./PfLoanProfileList.vue?vue&type=style&index=0&id=5dd1ae99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports